'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Mask = require('./Mask');

var _Mask2 = _interopRequireDefault(_Mask);

var _Source = require('./Source');

var _Source2 = _interopRequireDefault(_Source);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var wrapperStyle = {
  position: 'relative'
};

var videoStyle = {
  width: '100%'
};

var SublimeVideo = function (_React$Component) {
  _inherits(SublimeVideo, _React$Component);

  function SublimeVideo(props) {
    _classCallCheck(this, SublimeVideo);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleMaskClick = _this.handleMaskClick.bind(_this);
    return _this;
  }

  SublimeVideo.prototype.handleMaskClick = function handleMaskClick(shouldPlay) {
    var video = _reactDom2["default"].findDOMNode(this.refs.video);
    if (shouldPlay) {
      setTimeout(function () {
        return video.play();
      }, 300);
    } else {
      video.pause();
    }
  };

  SublimeVideo.prototype.render = function render() {
    var _props = this.props,
        style = _props.style,
        autoPlay = _props.autoPlay,
        children = _props.children,
        rest = _objectWithoutProperties(_props, ['style', 'autoPlay', 'children']);

    return _react2["default"].createElement(
      'section',
      { style: _extends({}, wrapperStyle, style) },
      _react2["default"].createElement(
        'video',
        _extends({ ref: 'video' }, rest, { autoPlay: autoPlay, style: videoStyle }),
        children
      ),
      _react2["default"].createElement(_Mask2["default"], { defaultVisible: !autoPlay,
        onClick: this.handleMaskClick
      })
    );
  };

  return SublimeVideo;
}(_react2["default"].Component);

exports["default"] = SublimeVideo;


SublimeVideo.propTypes = {
  autoPlay: _propTypes2["default"].bool,
  style: _propTypes2["default"].object,
  children: _propTypes2["default"].object
};

SublimeVideo.Source = _Source2["default"];
module.exports = exports['default'];